import React, { useEffect, useState } from "react";
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface Props {
    clearHandler: (value: string) => any;
    searchHandler: (value: string) => any;
}

const Search = ({ clearHandler, searchHandler }: Props) => {
    const [showClearIcon, setShowClearIcon] = useState("none");
    const [input, setInput] = useState("");

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        setInput(event.target.value);
    };

    const handleSearchClick = (): void => {
        searchHandler(input);
    };

    const handleClearClick = (): void => {
        setInput("");
        clearHandler("");
    };

    useEffect(() => {
        setShowClearIcon(input === "" ? "none" : "flex");
    }, [input]);
    return (
        <TextField
            fullWidth
            margin={"normal"}
            size="small"
            variant="outlined"
            onChange={handleChange}
            InputProps={{
                startAdornment: (
                    <InputAdornment
                        position="start"
                        onClick={handleSearchClick}
                        sx={{
                            ":hover": { cursor: "pointer" },
                        }}
                    >
                        <SearchIcon />
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment
                        position="end"
                        style={{ display: showClearIcon }}
                        onClick={handleClearClick}
                        sx={{
                            ":hover": { cursor: "pointer" },
                        }}
                    >
                        <ClearIcon />
                    </InputAdornment>
                ),
            }}
            value={input}
        />
    );
};

export default Search;
